import React, {useEffect, useState, useContext} from 'react';
import { useFetchLegend } from '../hooks/useFetchLegend';
import { AppContext } from '../components/AppContext';

const LegendContent = () => {    
    // { geoserverUrl, layerName, data, setLegendData }
    const { mapData, config, mapLegendData, setMapLegendData } = useContext(AppContext);
    const [geoserverUrl, setGeoserverUrl] = useState('');
    const [layer, setLayer] = useState('');
    const [style, setStyle] = useState('');
    const [legend, setLegend] = useState('');

    useEffect( () => {
        if (config) setGeoserverUrl(config.map.geoserverUrl)
      }, [config])

    useEffect( () => {
        if (mapData) setLayer(mapData.layer)
      }, [mapData])

    useEffect( () => {
        if (mapData) setStyle(mapData.style)
      }, [mapData])

    useEffect( () => {
        if (mapData) setLegend(mapData.legend)
      }, [mapData])
    
    const legendData = useFetchLegend(geoserverUrl, layer, style);

    useEffect( () => {
        setMapLegendData(legendData)
    }, [legendData])    

    if (mapLegendData !== '' && legend) {        
        return (          
            <div className='legend-content'>
            {mapLegendData.map((rule, index) => (
                <div key={index} className="legend-item">
                <div className="color-box" style={{ backgroundColor: rule.symbolizers[0].Polygon.fill }}></div>
                <span>{rule.title}</span>
                </div>
            ))}
            </div> 
        );
    }
};

export default LegendContent;